import Cell from "./Cell";
import CreationManager from "../../managers/CreationManager";
import Utils from "../../utils/Utils";
import ResourcesDispatcher from "../../config/ResourcesDispatcher";
export default class Reel {
    constructor(scene, x, y, index, orientation, expanding) {
        this.index = 0;
        this.spinProgressValue = { value: 0 };
        this.spinAnimationDuration = 50;
        this.suspenseDuration = 3000;
        this.virtualReelPosition = 0;
        this.realMemoIndex = 0;
        this.scene = scene;
        this.gameLogicVariableManager = window.GameLogicVariableManager;
        this.gameDataManager = window.GameDataManager;
        this.index = index;
        this.numOfCellsPerReel = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_CELLS_PER_REEL;
        this.numOfExtraCellsPerReel = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_EXTRA_CELLS_PER_REEL;
        this.lastCellIndex = this.numOfCellsPerReel + this.numOfExtraCellsPerReel - 1;
        this.cellSize = ResourcesDispatcher.GAME_CONSTANTS.CELL_SIZE;
        this.numOfReels = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_REELS;
        this.container = this.scene.add.container(x, y);
        let cellCreation = CreationManager.createCells(this.scene, this, this.container);
        this.cells = cellCreation.cells;
        this.cellPosition = cellCreation.cellPositions;
        this.createReelMask(orientation);
        this.soundScatterInReel = ResourcesDispatcher.SOUNDS.SCATTER_IN_REEL;
        this.soundReelSuspence = ResourcesDispatcher.SOUNDS.RULLO_SUSPENSE;
        this.suspenseSpine = this.scene.add.spine(ResourcesDispatcher.GAME_CONSTANTS.REEL_SIZE.width / 2, ResourcesDispatcher.GAME_CONSTANTS.REEL_SIZE.height / 2, ResourcesDispatcher.SPINES.Reel_Suspense.jsonKey, ResourcesDispatcher.SPINES.Reel_Suspense.atlasKey).setOrigin(.5, .5).setVisible(false);
        this.animationsContainer = this.scene.add.container(x, y);
        this.animationsContainer.add(this.suspenseSpine);
        if (expanding) {
            this.expandingWild = CreationManager.createExpandingWild(this.scene, ResourcesDispatcher.GAME_CONSTANTS.CELLS_POSITION, 2, this);
            this.container.add(this.expandingWild.getContainer());
        }
    }
    createReelMask(orientation) { }
    setIndex(index) {
        this.index = index;
    }
    /** PUBLIC GETTERS **/
    getIndex() {
        return this.index;
    }
    getContainer() {
        return this.container;
    }
    getAnimationsContainer() {
        return this.animationsContainer;
    }
    getCell(index) {
        return this.cells[index];
    }
    getCells() {
        return this.cells;
    }
    /*******************/
    enableSuspense() {
        this.suspense = true;
    }
    setReelBackgroundSuspense() {
        this.suspenseSpine.visible = true;
        this.suspenseSpine.animationState.addAnimation(0, "animation", true);
    }
    resetReelBackground() {
        this.suspenseSpine.visible = false;
        this.suspenseSpine.animationState.clearTrack(0);
        this.suspenseSpine.animationState.setEmptyAnimations(0);
    }
    resetFlagsAndCounters() {
        this.resetReelBackground();
        this.turnOn();
        this.virtualReelPosition = Utils.getRandomInt(0, this.scene.gameArea.virtualGrid[this.index].length - 1);
        this.spinProgressValue = { value: 0 };
        this.stopped = false;
        this.forced = false;
        this.suspense = false;
        this.canStop = false;
        this.mustStop = false;
        this.suspenseStarted = false;
        this.mustEnableSuspense = false;
        this.mustEnableStop = false;
        this.realMemoIndex = 0;
        this.removeStopEvent();
    }
    turnOn() {
        this.getCells().forEach(c => c.turnOn());
    }
    turnOff() {
        this.getCells().forEach(c => c.turnOff());
    }
    resetCellsPositions() {
        this.getCells().forEach((cell, index) => {
            cell.getContainer().y = (this.cellSize.height * index) - (this.cellSize.height / 2);
        });
    }
    reIndexCells() {
        let resetCells = [];
        for (let i = 1; i < this.numOfCellsPerReel + this.numOfExtraCellsPerReel; i++) {
            resetCells[i - 1] = this.getCell(i);
            this.getCell(i).setIndex(i - 1);
        }
        this.getCell(0).setIndex(this.lastCellIndex);
        resetCells[this.lastCellIndex] = this.getCell(0);
        this.cells = resetCells;
    }
    configureSpinTween() { }
    spin() {
        this.spinProgress.play();
    }
    //TODO Refattorizzare l'animazione del bounce della singola cella
    playAnimationBounceSingleCell(cell, memoIndex) {
        const anims = cell.getSymbolSpineRaw(memoIndex).animations;
        if (anims && anims.length > 1) {
            const spine = cell.getSpine(memoIndex);
            const track = spine.animationState.addAnimation(Cell.WinAnimationTrack, anims[1], false); // <-- animations[1]
            track.alpha = Cell.WinAnimationAlpha;
            spine.setVisible(true);
            cell.getImage().setVisible(false);
            track.listener = {
                complete: () => {
                    // ripristino come fa playAnimation()
                    spine.setVisible(false);
                    spine.skeleton.setToSetupPose();
                    cell.getImage().setVisible(true);
                }
            };
        }
    }
    ;
    bounce() { }
    manageSuspense() {
        if (this.mustEnableSuspense && !this.forced) {
            this.scene.gameArea.reels[this.index + 1].startSuspense();
            this.stopEvent = this.scene.time.addEvent({
                delay: this.suspenseDuration,
                callbackScope: this,
                callback: () => {
                    this.scene.gameArea.reels[this.index + 1].canStop = true;
                },
            });
        }
        else if (this.mustEnableStop && !this.forced) {
            this.stopEvent = this.scene.time.addEvent({
                delay: this.spinAnimationDuration * (this.lastCellIndex),
                callbackScope: this,
                callback: () => {
                    this.scene.gameArea.reels[this.index + 1].canStop = true;
                },
            });
        }
        if (this.suspense && this.suspenseStarted) {
            this.stopReelSuspenseAnimation();
        }
        if (this.index === this.numOfReels - 1 || this.index === this.scene.gameArea.lastReelWithSuspense) {
            // stop scatter that are currently animating, if any
            this.scene.gameArea.reels.forEach((reel) => {
                reel.cells.forEach((_cell) => {
                });
            });
        }
    }
    startSuspense() {
        this.setReelBackgroundSuspense();
        this.turnOff();
        this.suspenseStarted = true;
        this.scene.soundManager.play(this.soundReelSuspence);
    }
    // This check is done for safety. It should NEVER happen that the reels are still spinning when this method is called.
    securityCheckStop() {
        if (this.spinProgress?.isPlaying()) {
            this.spinProgress.stop();
            this.resetCellsPositions();
        }
        else if (this.bounceTween1?.isPlaying()) {
            this.bounceTween1.stop();
            this.resetCellsPositions();
        }
        else if (this.bounceTween2?.isPlaying()) {
            this.bounceTween2.stop();
            this.resetCellsPositions();
        }
    }
    removeStopEvent() {
        if (this.stopEvent) {
            this.stopEvent.remove(false);
        }
        this.stopEvent = undefined;
    }
    stopReelSuspenseAnimation() {
        if (this.suspense && this.suspenseStarted) {
            this.suspense = false;
            this.suspenseStarted = false;
            this.resetReelBackground();
            this.turnOn();
        }
    }
    forceStop() {
        this.canStop = true;
        this.mustStop = true;
        this.forced = true;
        this.getCells().forEach(cell => cell.stopAnimation());
        this.removeStopEvent();
        if (this.suspense && this.suspenseStarted) {
            this.stopReelSuspenseAnimation();
        }
        this.scene.soundManager.stop(this.soundReelSuspence);
    }
}
